import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import dayjs from "dayjs";
import Path from "app/route/Path";
import Api from "app/services/api";
import StepsBar from "app/components/common/StepsBar";
import Input from "app/components/common/Input";
import Button from "app/components/common/Button";
import Label from "app/components/common/Label";
import Panel from "app/components/common/Panel";
import Form from "app/components/common/Form";
import SearchBox from "app/components/common/SearchBox";
import Salon from "app/components/Salon";
import BackBtn from "../../BackButton";
import Image from "app/components/Image";

function ProductDeliveryForm(props) {
  const { isPrefilled, stepId, children } = props;
  const productOrderItem = children;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchSalons, setSearchSalons] = useState([]);
  const [searchSalonsPending, setSearchSalonsPending] = useState(true);
  const [searchSalonsLoaded, setSearchSalonsLoaded] = useState(false);

  const steps = [
    { name: "発送登録" },
    { name: "入力確認" },
    { name: "登録完了" },
  ];

  const navigate = useNavigate();

  const {
    handleSubmit,
    // handleChange,
    // errors,
    values,
    setFieldValue,
    // resetForm,
    // touched,
    // handleBlur,
  } = useFormik({
    initialValues: {
      deliveryDate: dayjs().add(1, 'second'),
      orderAmount: isPrefilled ? productOrderItem.orderAmount : 0,
      salonId: isPrefilled ? productOrderItem.salonId : "",
      selectedSalonItem: isPrefilled ? productOrderItem.salon : {},
      // memo: "",
      memo: isPrefilled ? productOrderItem.memo : "",
    },
    onSubmit: async (values) => {
      console.log(productOrderItem.id, values)
      setIsSubmitting(true);
      const response = await (isPrefilled ? Api.labProductSalonOrder.orderSendDelivery(productOrderItem.id, values) : alert("実装待ち"));
      setIsSubmitting(false);
      gotoNextStep();
    },
  });

  const gotoPrevStep = () => {
    isPrefilled
      ? navigate(Path.product.order.delivery.confirmForm(productOrderItem.id, stepId - 1), {
          state: { productOrderItem: productOrderItem },
        })
      : navigate(Path.product.delivery.create(stepId - 1));
  };

  const gotoNextStep = () => {
    isPrefilled
      ? navigate(Path.product.order.delivery.confirmForm(productOrderItem.id, stepId + 1), {
          state: { productOrderItem: productOrderItem },
        })
      : navigate(Path.product.delivery.create(stepId + 1));
  };

  const step1IsValid = () => {
    if (!values.deliveryDate) {
      return false;
    }
    if (!values.salonId) {
      return false;
    }
    if (values.orderAmount <= 0) {
      return false;
    }
    // if (!values.memo) {
    //   return false;
    // }

    return true;
  };

  const productDeliveryFinished = () => {
    navigate(Path.product.order.list);
  };

  const searchClicked = async (evt) => {
    if (searchText === "") {
      return;
    }

    setSearchSalonsPending(false);
    setSearchSalonsLoaded(false);
    const response = await Api.salons.search(searchText);
    const items = response.data;
    setSearchSalons(items);
    setSearchSalonsLoaded(true);
  };

  const salonItemClicked = (salonItem) => {
    setFieldValue("salonId", salonItem.id);
    setFieldValue("selectedSalonItem", salonItem);
  };

  const onRemoveClicked = () => {
    setFieldValue("salonId", "");
    setFieldValue("selectedSalonItem", {});
  };

  const renderByStepIndex = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return (
          <>
            <Form.Row>
              <Form.Col>配送日</Form.Col>
              <Form.ColGrow>
                <Input.DateTimePicker
                  disablePast
                  name="deliveryDate"
                  className="w-full"
                  value={values.deliveryDate}
                  setValue={(newValue) => {
                    setFieldValue("deliveryDate", newValue);
                  }}
                ></Input.DateTimePicker>
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>数量</Form.Col>
              <Form.ColGrow>
                <Input.Field
                  name="orderAmount"
                  type="number"
                  className="w-full"
                  value={values.orderAmount}
                  setValue={(newValue) => {
                    setFieldValue("orderAmount", newValue);
                  }}
                ></Input.Field>
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>配送店舗</Form.Col>
              <Form.ColGrow>
                {isPrefilled ? (
                  <Salon.Grid.Item>{productOrderItem.salon}</Salon.Grid.Item>
                ) : (
                  <>
                    {values.salonId ? (
                      <>
                        <Salon.Grid.Item>
                          {values.selectedSalonItem}
                        </Salon.Grid.Item>
                        <Button.Danger onClick={onRemoveClicked}>
                          別の美容室を選択
                        </Button.Danger>
                      </>
                    ) : (
                      <>
                        <SearchBox
                          placeholder="美容室を探す"
                          value={searchText}
                          setValue={setSearchText}
                          onSearch={searchClicked}
                        />
                        <Salon.Grid.Grid
                          items={searchSalons}
                          loading={!searchSalonsLoaded}
                          pending={searchSalonsPending}
                        >
                          <Salon.Grid.Pending>
                            検索ボタンを押してください。
                          </Salon.Grid.Pending>
                          <Salon.Grid.Loading>検索中</Salon.Grid.Loading>
                          <Salon.Grid.Empty>
                            該当美容室がないです。
                          </Salon.Grid.Empty>
                          <Salon.Grid.Items>
                            {searchSalons.map((item) => (
                              <Salon.Grid.Item
                                key={item.id}
                                onClicked={salonItemClicked}
                                selected={item.id === values.salonId}
                              >
                                {item}
                              </Salon.Grid.Item>
                            ))}
                          </Salon.Grid.Items>
                        </Salon.Grid.Grid>
                      </>
                    )}
                  </>
                )}
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>発送商品</Form.Col>
              <Form.ColGrow>
                {isPrefilled ? (
                    <div className="bg-white px-2 py-6 flex flex-row" onClick={() => {}}>
                      <div>
                        <Image src={productOrderItem?.scalpLabProduct?.imageUrl} alt={productOrderItem?.scalpLabProduct?.name} />
                      </div>
                      <div className="px-2">
                        {/* <p className="font-bold">id: {productOrderItem?.scalpLabProduct?.id}</p> */}
                        <p className="font-bold">name: {productOrderItem?.scalpLabProduct?.name}</p>
                        <p className="font-bold">description: {productOrderItem?.scalpLabProduct?.description}</p>
                      </div>
                    </div>
                ) : (
                  <>
                    {/* {values.salonId ? (
                      <>
                        <Salon.Grid.Item>
                          {values.selectedSalonItem}
                        </Salon.Grid.Item>
                        <Button.Danger onClick={onRemoveClicked}>
                          別の美容室を選択
                        </Button.Danger>
                      </>
                    ) : (
                      <>
                        <SearchBox
                          placeholder="美容室を探す"
                          value={searchText}
                          setValue={setSearchText}
                          onSearch={searchClicked}
                        />
                        <Salon.Grid.Grid
                          items={searchSalons}
                          loading={!searchSalonsLoaded}
                          pending={searchSalonsPending}
                        >
                          <Salon.Grid.Pending>
                            検索ボタンを押してください。
                          </Salon.Grid.Pending>
                          <Salon.Grid.Loading>検索中</Salon.Grid.Loading>
                          <Salon.Grid.Empty>
                            該当美容室がないです。
                          </Salon.Grid.Empty>
                          <Salon.Grid.Items>
                            {searchSalons.map((item) => (
                              <Salon.Grid.Item
                                key={item.id}
                                onClicked={salonItemClicked}
                                selected={item.id === values.salonId}
                              >
                                {item}
                              </Salon.Grid.Item>
                            ))}
                          </Salon.Grid.Items>
                        </Salon.Grid.Grid>
                      </>
                    )} */}
                  </>
                )}
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>備考</Form.Col>
              <Form.ColGrow>
                <Input.MultilineField
                  name="memo"
                  className="w-full"
                  value={values.memo}
                  setValue={(newValue) => {
                    setFieldValue("memo", newValue);
                  }}
                ></Input.MultilineField>
              </Form.ColGrow>
            </Form.Row>
            <Panel.Justify className="!sticky !bottom-0 w-full bg-white p-2">
              <BackBtn url={Path.product.order.list}/>
              <Button.Primary onClick={gotoNextStep} disabled={!step1IsValid()}>
                次へ
              </Button.Primary>
            </Panel.Justify>
          </>
        );
      case 1:
        return (
          <div className="mx-2 space-y-4">
            <Form.Row>
              <Form.Col>配送日</Form.Col>
              <Form.ColGrow>
                <Label.DateTime dateFormat="YYYY-MM-DD">
                  {values.deliveryDate}
                </Label.DateTime>
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>数量</Form.Col>
              <Form.ColGrow>{values.orderAmount}</Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>配送店舗</Form.Col>
              <Form.ColGrow>
                {isPrefilled ? (
                  <Salon.Grid.Item>{productOrderItem.salon}</Salon.Grid.Item>
                ) : (
                  <Salon.Grid.Item>{values.selectedSalonItem}</Salon.Grid.Item>
                )}
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>配送商品</Form.Col>
              <Form.ColGrow>
                {isPrefilled ? (
                  <div className="bg-white px-2 py-6 flex flex-row" onClick={() => {}}>
                    <div>
                      <Image src={productOrderItem?.scalpLabProduct?.imageUrl} alt={productOrderItem?.scalpLabProduct?.name} />
                    </div>
                    <div className="px-2">
                      {/* <p className="font-bold">id: {productOrderItem?.scalpLabProduct?.id}</p> */}
                      <p className="font-bold">name: {productOrderItem?.scalpLabProduct?.name}</p>
                      <p className="font-bold">description: {productOrderItem?.scalpLabProduct?.description}</p>
                    </div>
                  </div>
                ) : (
                  <Salon.Grid.Item>{values.selectedSalonItem}</Salon.Grid.Item>
                )}
              </Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.Col>備考</Form.Col>
              <Form.ColGrow>
                <p className="whitespace-pre-wrap">{values.memo}</p>
              </Form.ColGrow>
            </Form.Row>
            <Panel.Justify className="!sticky !bottom-0 w-full bg-white p-2">
              <Button onClick={gotoPrevStep}>戻る</Button>
              <Button.Primary type="submit" loading={isSubmitting}>
                発送情報を登録します
              </Button.Primary>
            </Panel.Justify>
          </div>
        );

      case 2:
        return (
          <div className="text-center space-y-4 mx-2">
            <Form.Row>
              <Form.ColGrow>発送情報を登録しました</Form.ColGrow>
            </Form.Row>
            <Form.Row>
              <Form.ColGrow>
                <Button.Primary onClick={productDeliveryFinished}>
                  完了
                </Button.Primary>
              </Form.ColGrow>
            </Form.Row>
          </div>
        );

      default:
        return <></>;
    }
  };

  return (
    <>
      <StepsBar steps={steps} currentStepIndex={stepId} />
      <Form.Form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
        {renderByStepIndex(stepId)}
      </Form.Form>
    </>
  );
}

export default ProductDeliveryForm;
